import React from "react";
import styled from "styled-components";
import {PlatFormArtistCardProps} from "../types";

const PlatFormArtistCard: React.FC<PlatFormArtistCardProps> = ({
     name,
     isPrimary,
     onTogglePrimary,
     onDelete,
     }) => {
    const displayName = name?.length > 12 ? `${name.slice(0, 12)}...` : name;
    return (
        
    <Card>
        <TopRow>
            <Name title={name}>{displayName}</Name>
        </TopRow>
        <BottomRow>
            <ToggleSwitch
                onClick={onTogglePrimary}
                active={isPrimary}/>
            <Label
                style={{color: isPrimary ? '#000000' : '#00000080'}}>{isPrimary ? 'Primary' : 'Featuring'}</Label>
        </BottomRow>
    </Card>
    );
}

export default PlatFormArtistCard;

const Card = styled.div`
    width: 160px;
    height: 50px;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 3px 8px;
`;

const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;
`;

const Name = styled.p`
    color: #5a74ff;
    font-weight: 500;
    font-size: 14px;
    margin: 0;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

const BottomRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 5px;
`;

const ToggleSwitch = styled.div<{ active: boolean }>`
    width: 26px;
    height: 14px;
    background-color: ${({active}) => (active ? "#5a74ff" : "#ccc")};
    border-radius: 999px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &::before {
        content: "";
        position: absolute;
        top: 2px;
        left: ${({active}) => (active ? "14px" : "2px")};
        width: 10px;
        height: 10px;
        background-color: white;
        border-radius: 50%;
        transition: left 0.3s ease;
    }
`;

const Label = styled.span`
    font-size: 14px;
    font-weight: 500;
`;

